import 'styles/main.css';

import moment from 'moment';
moment.locale('et');

import '../node_modules/pixi.js';

import {useStrict} from 'mobx';
useStrict(true);

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'mobx-react';
import ViewStore from 'store/ViewStore';
import layoutStore from 'store/LayoutStore';
import RouteStore from 'store/RouteStore';
import App from './views/App/App';

import {routesArray} from 'routes';
const router = new RouteStore(routesArray);
const viewStore = new ViewStore(router, layoutStore);

const root = document.createElement('div');
root.id = 'app';
document.body.appendChild(root);

let DevTools = () => null;
if (__DEV__) DevTools = require('mobx-react-devtools').default;

render(
  <Provider view={viewStore} layout={layoutStore} router={router}>
    <div>
      <App />
      <DevTools position={{bottom: 0, right: 20}}/>
    </div>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js